module.exports = __webpack_public_path__ + "static/media/Torso_2.d5ff74b9.jpg";